import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sa-shell" }
const _hoisted_2 = { class: "sa-sidebar" }
const _hoisted_3 = { class: "sa-brand" }
const _hoisted_4 = { class: "sa-nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sa-side-footer" }
const _hoisted_7 = { class: "sa-ver" }
const _hoisted_8 = { class: "sa-main" }
const _hoisted_9 = { class: "sa-header" }
const _hoisted_10 = { class: "sa-head-title" }
const _hoisted_11 = { class: "sa-head-actions" }
const _hoisted_12 = { class: "sa-chip" }
const _hoisted_13 = { class: "sa-content" }
const _hoisted_14 = { class: "sa-card" }
const _hoisted_15 = {
  key: 0,
  class: "sa-switch-overlay"
}
const _hoisted_16 = { class: "sa-switch-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          color: "white",
          size: "26"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-shield-crown", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sa-brand-text" }, [
          _createElementVNode("span", { class: "sa-brand-title" }, "Super Admin"),
          _createElementVNode("span", { class: "sa-brand-sub" }, "Panou administrare")
        ], -1))
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (s) => {
          return (_openBlock(), _createElementBlock("button", {
            key: s.key,
            class: _normalizeClass(["sa-nav-item", { active: s.key === _ctx.activeKey }]),
            onClick: ($event: any) => (_ctx.activeKey = s.key)
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(s.icon), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("span", null, _toDisplayString(s.text), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, "v" + _toDisplayString(_ctx.APP_Version), 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sa-copy" }, "© 2026 Else Digital Solutions", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("header", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_icon, {
            icon: _ctx.activeSection.icon,
            size: "22",
            color: "#ff2c21"
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(_ctx.activeSection.text), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, [
            _createVNode(_component_v_icon, { size: "14" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-shield-check", -1)
              ]))]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createTextVNode(" Privilegii complete", -1))
          ]),
          _createVNode(_component_v_btn, {
            variant: "tonal",
            class: "sa-back",
            "prepend-icon": "mdi-arrow-left",
            loading: _ctx.switching,
            disabled: _ctx.switching,
            onClick: _ctx.backToApp
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Înapoi la aplicație ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "sa-logout",
            "prepend-icon": "mdi-logout",
            disabled: _ctx.switching,
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Deconectare ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("main", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeSection.comp)))
        ])
      ])
    ]),
    (_ctx.switching)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "46",
              width: "4",
              color: "#ff2c21"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sa-switch-text" }, "Se încarcă aplicația…", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}